export default "__VITE_ASSET__DkWb7m5M__"